import EngagementButtons from '@/app/components/EngagementButtons';
import { TickList } from '@/app/components/TickList';
import specialistImage from '@/modules/HomePageV2/sections/PlacementTypeSection/assets/specialist-permanent.png';
import Image from 'next/image';

import styles from './Content.module.scss';

export const PermanentContent = ({ isDesktop }: { isDesktop: boolean }) => {
  return (
    <div className={styles.contentContainer}>
      <p className={styles.contentText}>
        Enjoy stability, steady income, and meaningful team connections in hospitals and clinics
        across Australia and New Zealand. Whether you're looking to stay local or relocate
        long-term, we’ll connect you with roles that support your goals.
      </p>
      <TickList
        items={[
          'Predictable rosters and income',
          'Build long-term team relationships',
          'Clear pathways to develop your skills',
        ]}
      />
      <EngagementButtons
        trackAction="Placement section - Permanent"
        searchJobsUrl="/jobs/list?workType=Permanent&page=1"
      />
      {isDesktop && (
        <div className={styles.imageContainer}>
          <Image
            src={specialistImage}
            priority={false}
            alt=""
            aria-hidden
            width={417}
            height={396}
            style={{
              maxWidth: '100%',
              height: 'auto',
            }}
          />
        </div>
      )}
    </div>
  );
};
